import t9n from "@bimproject/t9n";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Component from "./Component";
import ComponentAdder from "./ComponentAdder";
import useBIMClass from "../../../../../../clients/taxonomy/useBIMClass";
import * as UI from "../../../../../../modules/ui-kit";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;

    & > div {
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > button {
            align-self: flex-end;
        }
    }
`;

export default function Index(props) {
    const { bimClass: bimClassID, disabled, onChange, value } = props;

    const { i18n } = useTranslation();

    const bimClass = useBIMClass(bimClassID);
    if (!bimClass.data?.bimClass) return undefined;
    if (!bimClass.data.bimClass.data.componentTypes?.length) return undefined;

    function update(component, update) {
        /*
        Add component
         */
        if (!component) {
            onChange([...value, update]);
            return;
        }

        /*
        Remove component
         */
        if (!update) {
            onChange(
                value.toSpliced(
                    value.indexOf(component),
                    1,
                )
            );
            return;
        }

        /*
        Change component
         */
        onChange(
            value.with(
                value.indexOf(component),
                {
                    ...component,
                    ...update,
                },
            )
        );
    }

    function add(componentTypeID) {
        update(
            undefined,
            {
                __id: crypto.randomUUID(),
                componentType: {
                    id: componentTypeID,
                },
            },
        );
    }

    return (
        <Styled>
            {
                bimClass
                    .data
                    .bimClass
                    .data
                    .componentTypes
                    .filter(
                        (componentType) => value.find(
                            (component) => component.componentType?.id === componentType.id
                        )
                    )
                    .map(
                        (componentType, i) => (
                            <div key={ i }>
                                {
                                    value
                                        .filter((c) => c.componentType?.id === componentType.id)
                                        .map(
                                            (component, i) => (
                                                <Component
                                                    bimClassID={ bimClassID }
                                                    componentTypeID={ component.componentType?.id }
                                                    key={ i }
                                                    onChange={ (updateSpec) => update(component, updateSpec) }
                                                    onRemove={ () => update(component, undefined) }
                                                    product={ component.product }
                                                    properties={ component.properties }
                                                    quantity={ component.quantity }
                                                    unitOfMeasurement={ component.unitOfMeasurement }
                                                />
                                            )
                                        )
                                }
                                <UI.Button
                                    disabled={ disabled }
                                    onClick={ () => add(componentType.id) }
                                >
                                    Add { t9n(componentType.name, i18n.language) }
                                </UI.Button>
                            </div>
                        )
                    )
            }
            <ComponentAdder
                bimClassID={ bimClassID }
                onSelect={ add }
            />
        </Styled>
    );
}
